module.exports = __webpack_public_path__ + "img/rocket.6f3edde6.jpg";